export const SHOP_PROMISE_COLOR = 'var(--shop-promise--primary-color)';
